import { getGridContextMenuList } from "../../../_helpers/getGridContextMenuList";
import { formatDate } from "../../../_helpers";
import { LabelColumnV2 } from "../../../components/DataGridV2/DataColumnsV2";
import { LOCAL_STORAGE_GRID_KEYS } from "../../../_constants";

export const getGenerationListColumns = ({
  t,
  i18n,
  apiRef,
  categories,
  keyPrefix,
  statusOptions
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    getValueForCopy: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        case "startDateTime":
          text = rowData.startDateTime ?  formatDate(new Date(rowData.startDateTime), true) : ''
          break;
        case "endDateTime":
          text = rowData.endDateTime ?  formatDate(new Date(rowData.endDateTime), true) : ""
          break;
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },
    getValueForFilter: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        case "objects":
          text = rowData.objects != null ? rowData.objects.toString() : "";
          break;
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },

    mode: "client"
  })
  return [
    {
      field: "title",
      headerName: t("general.subject"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.title}
            cellSubMenuOptions={{ options: getOptions({ field: "title", isQuickFilterDisplay: rowData?.title }), extraData: { fieldName: "title" } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "startDateTime",
      headerName: t('general.startDate'),
      flex: 1,
      minWidth: 90,
      type: "dateTime",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        const dateTimeString = formatDate(new Date(rowData.startDateTime), true);
        return <LabelColumnV2
          label={dateTimeString}
          cellSubMenuOptions={{ options: getOptions({ field: "startDateTime", isQuickFilterDisplay: rowData?.startDateTime }), extraData: { fieldName: "startDateTime", type: "dateTime" } }}
          request={rowData}
        />
      },
    },
    {
      field: "endDateTime",
      headerName: t('general.endDate'),
      flex: 1,
      minWidth: 90,
      type: "dateTime",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        const dateString = formatDate(new Date(rowData.endDateTime), true);
        return <LabelColumnV2
          label={dateString}
          cellSubMenuOptions={{ options: getOptions({ field: "endDateTime", isQuickFilterDisplay: rowData?.endDateTime }), extraData: { fieldName: "endDateTime", type: "dateTime" } }}
          request={rowData}
        />
      },
    },
    {
      field: "categoryId",
      headerName: t('general.category'),
      flex: 1,
      minWidth: 90,
      type: "singleSelect",
      valueOptions: categories?.map((c) => ({
        value: c.id,
        label: c.title,
      })) || [],
      filterable: 'false',
      download: false,
      renderCell: (params) => {
        const rowData = params.row;
        const category = categories && categories.length > 0 ? categories.find(c => c.id === rowData.categoryId) : '';
        return <LabelColumnV2
          tooltipLabel={category.title} label={category.title}
          cellSubMenuOptions={{ options: getOptions({ field: "categoryId", isQuickFilterDisplay: category.title}), extraData: { fieldName: "categoryId", type: "singleSelect" } }}
          request={rowData}
        />
      },
    },
    {
      field: "description",
      headerName: t('general.description'),
      flex: 1,
      minWidth: 110,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          tooltipLabel={rowData.description} label={rowData.description}
          cellSubMenuOptions={{ options: getOptions({ field: "description", isQuickFilterDisplay: Boolean(rowData.description) }), extraData: { fieldName: "description" } }}
          request={rowData}
        />
      },
    },
    {
      field: "chatMessage",
      headerName: t('general.message'),
      flex: 1,
      minWidth: 70,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          tooltipLabel={rowData.chatMessage} label={rowData.chatMessage}
          cellSubMenuOptions={{ options: getOptions({ field: "chatMessage", isQuickFilterDisplay: Boolean(rowData.chatMessage) }), extraData: { fieldName: "chatMessage" } }}
          request={rowData}
        />
      },
    },
    {
      field: "objects",
      headerName: t("general.objects"),
      flex: 1,
      minWidth: 90,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.objects}
            cellSubMenuOptions={{ options: getOptions({ field: "objects", isQuickFilterDisplay: Boolean(rowData.objects) }), extraData: { fieldName: "objects", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "status",
      headerName: t('general.status'),
      flex: 1,
      type:'singleSelect',
      valueOptions:statusOptions,
      minWidth: 70,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          tooltipLabel={rowData.status} label={rowData.status}
          cellSubMenuOptions={{ options: getOptions({ field: "status", isQuickFilterDisplay: Boolean(rowData.status) }), extraData: { fieldName: "status" , type:'singleSelect'} }}
          request={rowData}
        />
      },
    },
  ];
}


